import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AccountService, IAccount } from '../shared/account.service';
import { BlobStorageService } from '../../shared/blob-storage.service';
import { Account } from '../../account/shared/account.model';
import { ConfirmDialogComponent } from '../../shared/modals/confirm/confirm-dialog.component';
import { ImageDialogComponent } from '../../shared/image-grid/image-grid-dialog/image-dialog.component';
import { AccountDetailFormComponent } from './account-detail-form/account-detail-form.component';
import { forkJoin, Observable } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-account-detail',
  templateUrl: './account-detail.component.html',
  styleUrls: ['./account-detail.component.scss']
})
export class AccountDetailComponent implements OnInit {

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _accountService: AccountService,
    private _blobStorageService: BlobStorageService,
    private _location: Location,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
  ) { }

  titleText = '';
  id?: string | null;
  month?: string | null;
  readonly = true;
  account$?: Observable<IAccount>;
  account?: IAccount;
  receipt$?: Observable<string>;
  loadingError = false;

  @ViewChild('accountForm') accountForm?: AccountDetailFormComponent;

  goBack() {
    this._location.back();
  }

  ngOnInit() {
    this.id = this._activatedRoute.snapshot.paramMap.get('id');
    this.month = this._activatedRoute.snapshot.paramMap.get('month');
    if (this.id) {
      this.account$ = this._accountService.retrieveAccount(this.id, this.month || undefined).pipe(
        tap(account => this.account = account)
      );
    }
    this.titleText = `支払詳細${this.month ? '（確定済）' : ''}`;

    this.account$?.subscribe({
      next: account => {
        this.readonly = (this.month != null || account.archivedOn != null);
        this.receipt$ = this._blobStorageService.getReceipt((account.images || [])[0]);
      },
      error: e => {
        this.loadingError = true;
      }
    });
  }

  onClickUpdateButton() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: { title: '確認', message: '更新してもよろしいですか？' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && this.id) {
        this._accountService.updateAccount(this.id, this.accountForm?.formGroup?.value)
          .subscribe({
            next: () => {
              this._snackBar.open('更新しました。', 'はい', { duration: 2000 });
              this._router.navigate(['/']);
            },
            error: () => {
              this._snackBar.open('エラーが発生しました。', undefined, { duration: 2000 });
            }
          });
      }
    });
  }

  onClickDeleteButton() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: { title: '確認', message: '削除してもよろしいですか？' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && this.id) {
        forkJoin([
          this._accountService.deleteAccount(this.id),
          ...(this.account?.images?.map(img => this._blobStorageService.deleteReceipt(img)) || [])
        ]).subscribe({
          next: () => {
            this._snackBar.open('削除しました。', 'はい', { duration: 2000 });
            this._router.navigate(['/']);
          },
          error: () => {
            this._snackBar.open('エラーが発生しました。', undefined, { duration: 2000 });
          }
        });
      }
    });
  }

  openImageDialog(src: string): void {
    this.dialog.open(ImageDialogComponent, {
      data: src,
      maxWidth: '100vw',
      height: '100vh',
      panelClass: 'image-dialog'
    });
  }
}
